const updateMapImmutable = <Key, Value>(
    map: Map<Key, Value>,
    key: Key,
    value: Value
): Map<Key, Value> => {
    const newMap = new Map(map);
    newMap.set(key, value);
    return newMap;
};

export { updateMapImmutable };
